import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import ProgressBar from "../../../../UI/ProgressBar";
import { useGetCompanyBookSummaryQuery } from "../../../../../redux-toolkit/features/reports/ReportsApiSlice";
import { Error404 } from "../../../../UI/404/Error404";
import { SortIcon } from "../../../Manage Organization/Employee/EmployeeTable";
import emptyStateSearch from "../../../../../assets/employee/empty_state_search.svg";
import { ReportsTruncatedName } from "../../ReportsTruncatedName";

export const BookSummaryTable = ({
  check,
  searchQuery = "",
  getTableData,
  startDate,
  endDate,
}) => {
  const [sortBy, setSortBy] = useState("");
  const [sortType, setSortType] = useState("asc");

  const { data, isError, isLoading } = useGetCompanyBookSummaryQuery(
    {
      sortBy: sortBy,
      type: sortType,
      query: searchQuery,
      startDate,
      endDate,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  React.useEffect(() => {
    if (!data) return;
    getTableData && getTableData(data);
  }, [data]);

  const handleSorting = (sortKey) => {
    setSortBy(sortKey);
    setSortType(!sortType || sortType === "desc" ? "asc" : "desc");
  };

  React.useEffect(() => {}, [check]);

  if (isLoading) {
    return <ProgressBar />;
  }

  if (isError) {
    return <Error404 />;
  }

  const allFieldsDeselected = Object.values(check).every((v) => !v);
  return (
    <div
      style={
        allFieldsDeselected
          ? { overflow: "hidden", maxWidth: "100%", width: "100%" }
          : undefined
      }
    >
      <TableContainer
        sx={{
          height: allFieldsDeselected ? "auto" : "100%",
          maxHeight: allFieldsDeselected ? "none" : "calc(100vh - 270px)",
          padding: "0 1px",
          width: "100%",
          maxWidth: "100%",
          overflowX: allFieldsDeselected ? "hidden" : "auto",
          overflowY: allFieldsDeselected ? "hidden" : "auto",
        }}
      >
        <Table
          stickyHeader
          aria-label="sticky table"
          sx={
            allFieldsDeselected
              ? { tableLayout: "fixed", width: "100%", minWidth: 0 }
              : { minWidth: 1450 }
          }
        >
          <TableHead>
            <TableRow
              sx={{
                borderRadius: "20px 20px 0px 0px",
              }}
              className="tableUi__head"
            >
              {allFieldsDeselected ? (
                <TableCell
                  sx={{ borderRadius: "20px 20px 0px 0px" }}
                  align="center"
                >
                  Select fields to view data
                </TableCell>
              ) : (
                <>
                  {check.depName && (
                    <TableCell
                      sx={{ borderRadius: "20px 0px 0px 0px" }}
                      align="center"
                      onClick={() => handleSorting("company_name")}
                    >
                      <div className="tableUi__head_sortable">
                        Company Name <SortIcon sortOrder={sortType} />
                      </div>
                    </TableCell>
                  )}
                  {check.hod && (
                    <TableCell align="center">Company Admin</TableCell>
                  )}
                  {check.bookName && (
                    <TableCell
                      align="center"
                      onClick={() => handleSorting("name")}
                    >
                      <div className="tableUi__head_sortable">
                        Book Name <SortIcon sortOrder={sortType} />
                      </div>
                    </TableCell>
                  )}
                  {/* {check.bookId && <TableCell align="center">Book Id</TableCell>} */}
                  {check.bookCreator && (
                    <TableCell align="center">Book Creator</TableCell>
                  )}
                  {check.totalLevels && (
                    <TableCell align="center"> Total Levels</TableCell>
                  )}
                  {check.totalTasks && (
                    <TableCell align="center">Total Tasks</TableCell>
                  )}

                  {check.pointsAssigned && (
                    <TableCell
                      sx={{ borderRadius: "0px 20px 0px 0px" }}
                      align="center"
                    >
                      Points Assigned
                    </TableCell>
                  )}
                </>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {allFieldsDeselected ? (
              <TableRow>
                <TableCell
                  colSpan={1}
                  align="center"
                  sx={{
                    border: "none",
                    padding: "40px 20px",
                    verticalAlign: "middle",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "12px",
                    }}
                  >
                    <img
                      src={emptyStateSearch}
                      alt="No data"
                      style={{
                        width: "220px",
                        height: "165px",
                        marginTop: "150px",
                      }}
                    />
                  </div>
                </TableCell>
              </TableRow>
            ) : searchQuery && (!data?.data || data?.data.length === 0) ? (
              <TableRow>
                <TableCell
                  colSpan={Object.values(check).filter(Boolean).length || 6}
                  align="center"
                  sx={{
                    border: "none",
                    padding: "60px 20px",
                    height: "calc(100vh - 320px)",
                    verticalAlign: "middle",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "20px",
                      position: "absolute",
                      left: "50%",
                      top: "50%",
                      transform: "translate(-50%, -50%)",
                      width: "100%",
                      maxWidth: "100vw",
                    }}
                  >
                    <img
                      src={emptyStateSearch}
                      alt="No search results"
                      style={{
                        width: "220px",
                        height: "165px",
                        marginTop: "150px",
                      }}
                    />
                  </div>
                </TableCell>
              </TableRow>
            ) : (
              data &&
              data?.data?.map((row, index) => (
                <>
                  <TableRow
                    className="tableUi___body"
                    key={index}
                  >
                    {check.depName && (
                      <TableCell align="center">
                        <ReportsTruncatedName value={row?.company?.name} />
                      </TableCell>
                    )}

                    {check.hod && (
                      <TableCell align="center">
                        {" "}
                        {row?.company?.companyAdmin?.email}
                      </TableCell>
                    )}
                    {check.bookName && (
                      <TableCell align="center">{row?.name}</TableCell>
                    )}

                    {check.bookCreator && (
                      <TableCell align="center">
                        {row?.createdBy?.fname + " " + row?.createdBy?.lname}
                      </TableCell>
                    )}
                    {check.totalLevels && (
                      <TableCell align="center">{row?.levelCount}</TableCell>
                    )}
                    {check.totalTasks && (
                      <TableCell align="center"> {row?.tasksCount}</TableCell>
                    )}

                    {check.pointsAssigned && (
                      <TableCell align="center">
                        {row?.points}
                      </TableCell>
                    )}
                  </TableRow>
                </>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
